var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconViewMapHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "32px",
    viewBox: "0 0 35 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_view_map_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Devices-window:-view-options",
    transform: "translate(-977.000000, -603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_view_map_hover",
    transform: "translate(977.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L32.0007894,0 C33.6572077,0 35,1.33425951 35,2.99610022 L35,29.0038998 C35,30.6586002 33.6494043,32 32.0007894,32 L0,32 L0,0 Z",
    id: "bkgd",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,22 L26.0084049,22 C26.0001118,22.0000017 26,10 26,10 L9.99159507,10 C9.99988824,9.99999829 10,22 10,22 Z M26.0092049,8 C27.1086907,8 28,8.89451376 28,9.99406028 L28,22.0059397 C28,23.1072288 27.1017876,24 26.0092049,24 L9.99079514,24 C8.89130934,24 8,23.1054862 8,22.0059397 L8,9.99406028 C8,8.8927712 8.89821238,8 9.99079514,8 L26.0092049,8 Z M16,10 L14,10 L14,22 L16,22 L16,10 Z M22,10 L20,10 L20,22 L22,22 L22,10 Z",
    id: "Rectangle-22",
    fill: "#A5A5A5",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewMapHover);
export default __webpack_public_path__ + "static/media/icon_view_map_hover.5cffbe315574a507d56f778b7788495f.svg";
export { ForwardRef as ReactComponent };